import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { userActions } from '_actions';
import { buildingActions } from '_actions';

import { Layout, Image, Text, Butt } from 'sc-ui';
import { Form, Input, message, Icon, Button, Alert } from 'antd';

import styles from 'styles/styles';
import styled from 'styled-components';

const StyledLink = styled(Link)`
    font-size: 16px;
`;

const Logo = 'https://s3-us-west-2.amazonaws.com/smoothieclub-assets/sc-logo-svg.svg';
const GuestWindow = ({ title, history, children, login = false, register = false, forgotPassword = false }) => (
    <Layout.Base guest>
        <Layout body style={{paddingTop: '5%'}}>
            <Layout.Window>
                <Butt.Back icon="home" onClick={() => history.push('/home')}>Home</Butt.Back>
                <Image size="xlrg" src="https://s3-us-west-2.amazonaws.com/smoothieclub-assets/sc-logo-svg.svg" alt="Smoothie Club" margin="0 10px 20px 10px" />
                <Text size="med" color="scGray" style={{ marginBottom: styles.margin.lrg, textAlign: 'center' }}>{title}</Text>
                <React.Fragment>
                    {children}
                </React.Fragment>
                {login && <StyledLink to="/login" href="#">Login</StyledLink>}
                {register && <StyledLink to="/register" href="#">Register</StyledLink>}
                {forgotPassword && <StyledLink to="/forgotPassword" href="#">Forgot Password?</StyledLink>}
            </Layout.Window>
        </Layout>
    </Layout.Base>
);

export default withRouter(GuestWindow)



// WEBPACK FOOTER //
// ./src/_components/GuestWindow.jsx